import { Checkbox } from "@mui/material"

const BaseCheckbox = (props) => (
  <Checkbox
    sx={{
      "& .MuiSvgIcon-root": { fontSize: 24 },
      mr: 1.5,
      p: 0,
    }}
    {...props}
  />
)
export default BaseCheckbox
